<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="openAdd()"
      >添加</el-button>
      <el-button
        type="success"
        size="mini"
        icon="el-icon-refresh"
        @click="getRoleinfo()"
      >刷新</el-button>
      <span style="padding: 0 10px">管理员名称</span>
      <!-- 搜索框 -->
      <el-input
        v-model="name"
        placeholder="请输入管理员名称"
        style="width: 200px; height: 30px; line-height: 30px"
        clearable
        @keyup.enter.native="getRoleinfo()"
      />
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="getRoleinfo()"
      >筛选</el-button>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      style="width: 881px"
      height="calc(100vh - 240px )"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="account" label="管理员账号" width="140" />
      <el-table-column prop="userName" label="管理员昵称" width="200" />
      <!-- <el-table-column prop="web_user_roles" label="角色" width="200">
        <template slot-scope="scoped">{{
          scoped.row.account === "admin"
            ? "*：*：*"
            : roleNameEvent(scoped.row.web_user_roles)
        }}</template>
      </el-table-column> -->
      <el-table-column label="创建时间" width="240">
        <template slot-scope="scope">
          {{
            $parseTime(new Date(scope.row.createdAt), "{y}-{m}-{d} {h}:{i}:{s}")
          }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <span
            :style="scope.row.status === 1 ? 'color:#00c759' : 'color:red'"
          >{{ scope.row.status === 1 ? "正常" : "已禁用" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            icon="el-icon-edit"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            size="mini"
            icon="el-icon-key"
            @click="editPassword(scope.row)"
          >重置密码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getRoleinfo"
    />

    <!-- 添加编辑用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="570px"
      :close-on-click-modal="false"
      @closed="handleClose"
    >
      <!-- 添加编辑用户表格 -->
      <el-form
        ref="formData"
        :model="formData"
        label-width="120px"
        :rules="rules"
      >
        <el-form-item label="账号" prop="account">
          <el-input v-model="formData.account" placeholder="请输入管理员账号" />
        </el-form-item>
        <el-form-item v-if="!isEdit" label="密码" prop="passwords">
          <el-input
            v-model="formData.passwords"
            placeholder="请输入管理员密码"
            type="password"
          />
        </el-form-item>
        <el-form-item v-if="!isEdit" label="确定密码" prop="checkpassword">
          <el-input
            v-model="formData.checkpassword"
            placeholder="请再次输入管理员密码"
            type="password"
          />
        </el-form-item>
        <el-form-item label="管理员昵称" prop="userName">
          <el-input
            v-model="formData.userName"
            placeholder="请再次输入管理员昵称"
          />
        </el-form-item>
        <el-form-item v-if="isEdit" label="角色权限" prop="roleIds">
          <el-checkbox-group v-model="formData.roleIds">
            <el-checkbox
              v-for="(item, index) in options"
              :key="index"
              v-model="item.id"
              :label="item.id"
            >{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="edit-button"
            :loading="buttongLoding"
            @click="isEdit ? editManagement() : addManagement()"
          >保存并提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 重置密码弹窗 -->
    <el-dialog
      :visible.sync="dialogPassword"
      width="570px"
      :close-on-click-modal="false"
      @closed="handleClosePass"
    >
      <el-form
        ref="formData"
        :model="formPassword"
        label-width="120px"
        :rules="rules"
      >
        <el-form-item label="账号" prop="account">
          <el-input
            v-model="formPassword.account"
            :disabled="true"
            placeholder="请输入管理员账号"
          />
        </el-form-item>
        <el-form-item label="密码" prop="passwords">
          <el-input
            v-model="formPassword.passwords"
            placeholder="请输入管理员密码"
            type="password"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="edit-button"
            @click="submitPassword()"
          >确认重置密码</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination' // 引入分页器
import {
  addAdministrator,
  updateAdministrator,
  getAdministratorList,
  resetPas
} from '@/api/administrator.js'
import { getUserRole, addUserRole, updateUserRole } from '@/api/userRole.js'
import { getRoleList } from '@/api/role.js'
export default {
  name: 'Management',
  components: { Pagination },
  data() {
    // 自定义检验规则
    // 校验第一次密码
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.formData.checkpassword !== '') {
          this.$refs.formData.validateField('checkpassword')
        }
        callback()
      }
    }
    // 校验第二次密码
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formData.passwords) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      option: '', // 初始选项
      options: [], // 选择角色
      name: '', // 搜索的管理员名称
      showtabelData: [], // 展示的表单信息
      // 添加表单
      formData: {
        account: '',
        passwords: '',
        checkpassword: '',
        userName: '',
        roleIds: [],
        status: ''
      },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      dialogVisible: false, // 弹窗
      isEdit: false, // 是否是编辑弹窗
      loading: false, // 表格加载
      // 校验规则
      rules: {
        account: [
          { required: true, message: '请输入管理员账号', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入管理员昵称', trigger: 'blur' }
        ],
        passwords: [
          { validator: validatePass, trigger: 'blur', required: true }
        ],
        checkpassword: [
          { validator: validatePass2, trigger: 'blur', required: true }
        ],
        roleIds: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个角色',
            trigger: 'change'
          }
        ],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      buttongLoding: false, // 按钮加载
      // 角色接口分页参数
      pageRoleUtil: {
        pageNum: 1,
        pageSize: 100
      },
      formPassword: {
        account: '',
        passwords: ''
      },
      dialogPassword: false
    }
  },
  mounted() {
    this.getRoleinfo()
    this.getAllrolesEvent()
  },
  methods: {
    // 禁止选择
    checkSelectable(row) {
      return row.isSystem == false
    },
    // 筛选
    select() {
      this.pageNum = 1
      this.getRoleinfo()
    },
    // 获取角色列表
    getAllrolesEvent() {
      getRoleList(this.pageRoleUtil)
        .then((res) => {
          this.options = res.rows
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    // 获取表单信息
    getRoleinfo() {
      var params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userName: this.name
      }
      this.loading = true
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      getAdministratorList(params)
        .then((res) => {
          console.log(res, '....00')
          this.showtabelData = res.rows
          this.total = res.count
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 关闭添加弹窗
    handleClose() {
      this.formData = {
        account: '',
        passwords: '',
        checkpassword: '',
        userName: '',
        roleIds: [],
        status: ''
      }
      this.dialogVisible = false
    },
    // 关闭添加弹窗
    handleClosePass() {
      this.formPassword = {
        account: '',
        passwords: ''
      }
      this.dialogPassword = false
    },

    // 打开新增弹窗
    openAdd() {
      this.getAllrolesEvent()
      this.dialogVisible = true
      this.isEdit = false
    },
    // 打开编辑弹窗
    edit(row) {
      console.log(row, 'row...')
      this.formData = { ...this.formData, ...JSON.parse(JSON.stringify(row)) }
      this.formData.roleIds =
        row.web_user_roles && row.web_user_roles.length > 0
          ? row.web_user_roles.map((it) => it.roleId)
          : []
      this.getAllrolesEvent()
      this.isEdit = true
      this.dialogVisible = true
      console.log(this.formData, '77777777777')
    },
    // 添加用户
    addManagement() {
      console.log(this.formData, 'this.formData.....')
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.buttongLoding = true
          addAdministrator(this.formData)
            .then((res) => {
              this.$message.success('添加成功')
              this.dialogVisible = false
              this.getRoleinfo()
              this.buttongLoding = false
            })
            .catch((err) => {
              this.$message.error(err || '服务器错误，请稍后重试')
              this.buttongLoding = false
            })
        }
      })
    },
    addUserRoleEvent(userId) {
      const userRoleArr = []
      console.log(this.formData.roleIds, 'this.formData.roleIds')
      const roleNameList = []
      for (let i = 0; i < this.formData.roleIds.length; i++) {
        for (let j = 0; j < this.options.length; j++) {
          if (this.formData.roleIds[i] === this.options[j].id) {
            roleNameList.push(this.options[j].roleKey)
          }
        }
      }
      this.formData.roleIds.map((item) => {
        userRoleArr.push({
          roleId: item,
          userId
        })
      })
      addUserRole({ userId, userRoleArr, roleNameList }).then((res) => {
        this.getRoleinfo()
      })
    },
    // 更新用户信息
    editManagement() {
      console.log(this.formData, '99888')
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.buttongLoding = true
          updateAdministrator(this.formData)
            .then((res) => {
              this.$message.success('修改成功')
              this.dialogVisible = false
              this.buttongLoding = false
              // 添加用户角色
              this.addUserRoleEvent(this.formData.id)
            })
            .catch((err) => {
              this.$message.error(err || '服务器错误，请稍后重试')
              this.buttongLoding = false
            })
        }
      })
    },
    // 格式化角色
    roleNameEvent(roleIds) {
      const newArr = []
      if (roleIds && roleIds.length > 0) {
        for (const key of roleIds) {
          for (let j = 0; j < this.options.length; j++) {
            if (this.options[j].id === key.roleId) {
              newArr.push(this.options[j].name)
              break
            }
          }
        }
      }
      return newArr.join(',')
    },
    editPassword(data) {
      this.dialogPassword = true
      this.formPassword.account = data.account
      this.formPassword.passwords = data.passwords
    },
    submitPassword() {
      if (!this.formPassword.passwords) {
        return this.$message.warning('请输入重置的密码')
      }
      resetPas(this.formPassword)
        .then((res) => {
          this.$message.success('密码重置成功')
          this.dialogPassword = false
        })
        .catch((error) => {
          this.$message.error(error || '密码重置失败')
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
